import { render, staticRenderFns } from "./ScoutTop.vue?vue&type=template&id=036a04af"
import script from "./ScoutTop.vue?vue&type=script&lang=js"
export * from "./ScoutTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports